// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WOykP","index":"styles_index__3qsEh"};